/* eslint-disable */
export default {
  toolTip: 'View in {crmName}',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
